import { useApi } from '@/api';
import { TableSkeleton } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  CurrencyValue,
  EtherScanPictogram,
  Flex,
  useTableProps,
  DataTable,
  RelativeDateTime
} from '@blockanalitica/ui';

export default function EventsTable({ address }) {
  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });
  const [data, error] = useApi({
    url: '/accounting/operation/events/',
    queryParams: {
      page: pagination.currentPage,
      limit: pagination.pageSize,
      sort: sorting.currentSorting,
      address: address
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Type',
        getCell: (row) => row.event,
        columnSize: ['minmax(20px, auto)'],
        cellAlign: 'flex-start',
        headerAlign: 'flex-start',
        sortingField: 'type'
      },
      {
        header: 'Amount',
        getCell: (row) => (
          <CurrencyValue value={row.amount} options={{ currency: 'USD' }} />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'amount'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex gap={['xs', '2xs']} color="muted">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'order_index'
      }
    ];

    return (
      <>
        <DataTable
          rows={data['data']['results']}
          columns={columns}
          getKey={(row) => row.order_index}
          sorting={sorting}
          pagination={{
            ...pagination,
            totalRecords: data.data.pagination.total
          }}
        />
      </>
    );
  }
  return <TableSkeleton />;
}
